import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { Person } from "../../../utils/backend-types";
import type { Doc } from "../../DeliveryOverview/DeliveryOverview.types";

function getSupplierColumn(persons: Array<Person>): MRT_ColumnDef<Doc> {
  return {
    header: "Lieferant",
    accessorKey: "supplier",
    accessorFn: (row) =>
      persons.find((person) => person.id === row.supplier)?.name || "",
    filterVariant: "multi-select"
  };
}

export { getSupplierColumn };
